module.exports = ".profile-container {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n}\r\n\r\n.detail-div {\r\n    width: 100%;\r\n}\r\n\r\n.parents-info {\r\n    padding: 8px 0;\r\n    margin-top: 8px;\r\n    border-bottom: 1px dashed #ddd;\r\n    border-top: 1px dashed #ddd;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/member-summary/member-summary.component.css
// module id = ./src/app/shared/components/member-summary/member-summary.component.css
// module chunks = main